// extracted by mini-css-extract-plugin
export default {"title":"About2_title__eN44r","image":"About2_image__uhlbW","headingContainer":"About2_headingContainer__qs3Nc","imageGrid":"About2_imageGrid__s6WxW"};